@if (column.includes('LineSwitchEnabled')) {
  <div class="pl-35">
    <span class="base mr-10">Enable feature</span>
    <label class="ml-minus-6" aria-hidden="true">
      <input type="checkbox" class="primary-checkbox" id="isLineSwitchEnabled"
        (change)="toggleIsLineSwitchEnabled($event.target.checked)" [(ngModel)]="isLineSwitchEnabled"
        [checked]='isLineSwitchEnabled' aria-label="Enable feature" />
        <span class="extra-border-enablefeat"></span>
      </label>
    </div>
  }
  @if (column.includes('HighVLevel')) {
    <div id="corridor_normalLevel_container" class="row slider-container"
      [ngClass]="{'dtldisbaled': corridordisbaled}">
      <div id="LineSwitch-highVlevel-text" class="col-1 label signifyBookmd text-mindim dim-margin">High V level</div>
      @if (!quickConfigvalue) {
        <span id="LineSwitch-highVlevel-text-min" class="signifyBookmd text-mindim  sliderMinValue col-1"
        >{{lineswitchHighVLevelMin}}</span>
      }
      @if (quickConfigvalue) {
        <div class="col-2">
          <div class="row">
            <div class="col-2"></div>
            <div class="col-2 minValMargin">
              <span class=" signifyBookmd minValue"> min {{ lineswitchHighVLevelMin }}</span>
            </div>
            <div class="col-2">
              <span class="signifyBookmd maxValue"> max {{ lineswitchHighVLevelMax }}</span>
            </div>
          </div>
        </div>
      }
      @if (!quickConfigvalue) {
        <div class="col-6 curvePadding sliderCss" [ngClass]="{'disbaleStyle': corridordisbaled}">
          <ngx-slider type="normalType"
            [options]="lineswitchHighVOption"
            [value]="HighVLevelValue"
            (userChangeEnd)="lineswitchHighVValueChange($event.value)"
            ngDefaultControl>
          </ngx-slider>
          @if (HighVLevelValue===0) {
            <span class="label-time-based-override"> <img src="icon_indicator_alert_high_16dip.png"
            class="warning-img" alt="Alert"></span>
            <span>Lamp will be turned of at light level 0%</span>
          }
        </div>
      }
      @if (!quickConfigvalue) {
        <span id="LineSwitch-highVlevel-text-max" class="signifyBookmd text-mindim  col-1 maxValueCss"
        >{{lineswitchHighVLevelMax}}</span>
      }
      <div class="col-3 d-flex align-items-center">
        <input type="number"
          [value]="HighVLevelDisplayValue"
          (input)="onHighVLevelInput($event.target.value)"
          id="lineswitch_HighVLevelValue_txtbox"
          (keypress)="numberOnly($event)"
          (keydown.Tab)="onHighVLevelBlur($event.target.value)"
          (keydown.enter)="onHighVLevelBlur($event.target.value)"
          [ngClass]="{'showingError': inputError['HighVLevel']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
          class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
          [disabled]="corridordisbaled"
          [min]="lineswitchHighVLevelMin"
          [max]="lineswitchHighVLevelMax" />
          <p class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</p>
        </div>
      </div>
    }
    @if (column.includes('LowVLevel') ) {
      <div id="corridor_BackgroundLevel_container" class="row slider-container"
        [ngClass]="{'dtldisbaled': corridordisbaled}">
        <div id="LineSwitch-lowVlevel-text" class="col-1 label signifyBookmd text-mindim dim-margin">Low V level</div>
        @if (!quickConfigvalue) {
          <span id="LineSwitch-lowVlevel-text-min" class="signifyBookmd text-mindim  sliderMinValue col-1"
          >{{lineswitchLowVLevelMin}}</span>
        }
        @if (quickConfigvalue) {
          <div class="col-2">
            <div class="row">
              <div class="col-2"></div>
              <div class="col-2 minValMargin">
                <span class=" signifyBookmd minValue"> min {{ lineswitchLowVLevelMin }}</span>
              </div>
              <div class="col-2">
                <span class="signifyBookmd maxValue"> max {{ lineswitchLowVLevelMax }}</span>
              </div>
            </div>
          </div>
        }
        @if (!quickConfigvalue) {
          <div class="col-6 curvePadding sliderCss" [ngClass]="{'disbaleStyle': corridordisbaled}">
            <ngx-slider [options]=lineswitchLowVLevelOption [value]=lineswitchLowVLevelValue
              (mouseup)="sliderEvent(formControl.value)" (userChangeEnd)="lineswitchLowVLevelChange($event.value)"
              ngDefaultControl>
            </ngx-slider>
            @if (ngModelval['lineswitchLowVLevelValue']===0) {
              <span class="label-time-based-override"> <img src="icon_indicator_alert_high_16dip.png"
              class="warning-img" alt="Alert"></span>
              <span>Lamp will be turned of at light level 0%</span>
            }
          </div>
        }
        @if (!quickConfigvalue) {
          <span id="LineSwitch-lowVlevel-text-max" class="signifyBookmd text-mindim  col-1 maxValueCss"
          >{{lineswitchLowVLevelMax}}</span>
        }
        <div class="col-3 d-flex align-items-center">
          <input type="tel" [value]="lineswitchLowVLevelDisplayValue"
            (input)="onLowVLevelInput($event.target.value)"
            (keydown.Tab)="onLowVLevelBlur($event.target.value)" (keydown.enter)="onLowVLevelBlur($event.target.value)"
            id="lineswitch_LowVLevelValue_txtbox"
            (keypress)="numberOnly($event)"
            [ngClass]="{'showingError': inputError['LowVLevel']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard ': quickConfigvalue===true}"
            class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
            [disabled]="corridordisbaled" />
            <p class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</p>
          </div>
        </div>
      }


      @if (column.includes('FadeUpTime') ) {
        <div id="corridor_DelayTime_container" class="row slider-container"
          [ngClass]="{'dtldisbaled': corridordisbaled}">
          <div id="LineSwitch-fadeUpTime-text" class="col-1 label signifyBookmd text-mindim dim-margin">Fade up time</div>
          @if (!quickConfigvalue) {
            <span id="LineSwitch-fadeUpTime-text-min" class="signifyBookmd text-mindim  sliderMinValue col-1"
            >{{lineswitchFadeUpTimeMin}}</span>
          }
          @if (quickConfigvalue) {
            <div class="col-2">
              <div class="row">
                <div class="col-2"></div>
                <div class="col-2 minValMargin">
                  <span class=" signifyBookmd minValue"> min {{ lineswitchFadeUpTimeMin }}</span>
                </div>
                <div class="col-2">
                  <span class="signifyBookmd maxValue"> max {{ lineswitchFadeUpTimeMax }}</span>
                </div>
              </div>
            </div>
          }
          @if (!quickConfigvalue) {
            <div class="col-6 curvePadding sliderCss" [ngClass]="{'disbaleStyle': corridordisbaled}">
              <ngx-slider [options]=lineswitchFadeUpTimeOption [value]=lineswitchFadeUpTimeValue
                (mouseup)="sliderEvent(formControl.value)" (userChangeEnd)="lineswitchFadeUpTimeChange($event.value)"
                ngDefaultControl>
              </ngx-slider>
            </div>
          }
          @if (!quickConfigvalue) {
            <span id="LineSwitch-fadeUpTime-text-max" class="signifyBookmd text-mindim  col-1 maxValueCss"
            >{{lineswitchFadeUpTimeMax}}</span>
          }
          <div class="col-3 d-flex align-items-center">
            <input type="tel" [value]="lineswitchFadeUpTimeDisplayValue"
              (input)="onFadeUpTimeInput($event.target.value)"
              (keydown.Tab)="onFadeUpTimeBlur($event.target.value)" (keydown.enter)="onFadeUpTimeBlur($event.target.value)"
              id="lineswitch_FadeUpTimeValue_txtbox"
              (keypress)="numberOnly($event)"
              [ngClass]="{'showingError': inputError['FadeUpTime']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
              class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
              [disabled]="corridordisbaled" />
              <p class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">sec</p>
            </div>
          </div>
        }
        @if (column.includes('FadeDownTime') ) {
          <div id="corridor_FadeTimeIndex_container" class="row slider-container"
            [ngClass]="{'dtldisbaled': corridordisbaled}">
            <div id="LineSwitch-fadeDownTime-text" class="col-1 label signifyBookmd text-mindim dim-margin">Fade down time</div>
            @if (!quickConfigvalue) {
              <span id="LineSwitch-fadeDownTime-text-min" class="signifyBookmd text-mindim  sliderMinValue col-1"
              >{{lineswitchFadeDownTimeMin}}</span>
            }
            @if (quickConfigvalue) {
              <div class="col-2">
                <div class="row">
                  <div class="col-2"></div>
                  <div class="col-2 minValMargin">
                    <span class=" signifyBookmd minValue"> min {{ lineswitchFadeDownTimeMin }}</span>
                  </div>
                  <div class="col-2">
                    <span class="signifyBookmd maxValue"> max {{ lineswitchFadeDownTimeMax }}</span>
                  </div>
                </div>
              </div>
            }
            @if (!quickConfigvalue) {
              <div class="col-6 curvePadding sliderCss" [ngClass]="{'disbaleStyle': corridordisbaled}">
                <ngx-slider [options]=lineswitchFadeDownTimeOption [value]=lineswitchFadeDownValue
                  (mouseup)="sliderEvent(formControl.value)" (userChangeEnd)="lineswitchFadeDownTimeChange($event.value)"
                  ngDefaultControl>
                </ngx-slider>
              </div>
            }
            @if (!quickConfigvalue) {
              <span id="LineSwitch-fadeDownTime-text-max" class="signifyBookmd text-mindim  col-1 maxValueCss"
              >{{lineswitchFadeDownTimeMax}}</span>
            }
            <div class="col-3 d-flex align-items-center">
              <input type="tel" [value]="lineswitchFadeDownDisplayValue"
                (input)="onFadeDownTimeInput($event.target.value)"
                (keydown.Tab)="onFadeDownTimeBlur($event.target.value)" (keydown.enter)="onFadeDownTimeBlur($event.target.value)"
                id="lineswitch_FadeDownTimeValue_txtbox"
                (keypress)="numberOnly($event)"
                [ngClass]="{'showingError': inputError['FadeDownTime']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
                class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
                [disabled]="corridordisbaled" />
                <p class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">sec</p>
              </div>
            </div>
          }
          @if (column.includes('SwitchOffDelayTime') ) {
            <div [id]="'corridor_FadeTimeIndex_container'" class="row slider-container"
              [ngClass]="{'dtldisbaled': corridordisbaled}">
              <div id="LineSwitch-switchOffDelay-text" class="col-1 label signifyBookmd text-mindim dim-margin">Switch off delay</div>
              @if (!quickConfigvalue) {
                <span id="LineSwitch-switchOffDelay-text-min" class="signifyBookmd text-mindim  sliderMinValue col-1"
                >{{lineswitchOffDelayTimeMin}}</span>
              }
              @if (quickConfigvalue) {
                <div class="col-2">
                  <div class="row">
                    <div class="col-2"></div>
                    <div class="col-2 minValMargin">
                      <span class=" signifyBookmd minValue"> min {{ lineswitchOffDelayTimeMin }}</span>
                    </div>
                    <div class="col-2">
                      <span class="signifyBookmd maxValue"> max {{ lineswitchOffDelayTimeMax }}</span>
                    </div>
                  </div>
                </div>
              }
              @if (!quickConfigvalue) {
                <div class="col-6 curvePadding sliderCss" [ngClass]="{'disbaleStyle': corridordisbaled}">
                  <ngx-slider [options]=lineswitchOffDelayTimeOption [value]=lineswitchOffDelayValue
                    (mouseup)="sliderEvent(formControl.value)" (userChangeEnd)="lineSwitchoffDelayTimeChange($event.value)"
                    ngDefaultControl>
                  </ngx-slider>
                </div>
              }
              @if (!quickConfigvalue) {
                <span id="LineSwitch-switchOffDelay-text-max" class="signifyBookmd text-mindim  col-1 maxValueCss"
                >{{lineswitchOffDelayTimeMax}}</span>
              }
              <div class="col-3 d-flex align-items-center">
                <input type="tel" [value]="lineswitchOffDelayDisplayValue"
                  (input)="onSwitchOffDelayTimeInput($event.target.value)"
                  (keydown.Tab)="onSwitchOffDelayTimeBlur($event.target.value)" (keydown.enter)="onSwitchOffDelayTimeBlur($event.target.value)"
                  id="lineswitch_switchOffDelayTimeValue_txtbox"
                  (keypress)="numberOnly($event)"
                  [ngClass]="{'showingError': inputError['SwitchOffDelayTime']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
                  class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
                  [disabled]="corridordisbaled" />
                  <p class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">sec</p>
                </div>
                @if (!quickConfigvalue && column.includes('2ndInactiveLevelEnabled') && show2ndInactiveLevelEnabled) {
                  <div id="LineSwitch-enableLevel2-text"
                    class="col-3 signifyBookmd sliderMinValueNew">Enable level 2
                    <label [ngClass]="{'disablingInfinteCheck': corridordisbaled, 'infiniteCss': quickConfigvalue===true }"
                      class="enable-feature" aria-hidden="true">
                      <input type="checkbox" [disabled]="corridordisbaled" [checked]="inactiveLevelEnabled"
                        [(ngModel)]="ngModelval['2ndInactiveLevelEnabled']" name="lampDisabled" class="primary-checkbox"
                        id="lampDisabled" (change)="enableLevel2($event.target.checked)" aria-label="Enable level 2" />
                        <span id="LineSwitch-enableLevel2-checkbox" class="extra-border-enablefeat"></span>
                      </label>
                    </div>
                  }
                </div>
              }
              @if (quickConfigvalue && column.includes('2ndInactiveLevelEnabled')&& show2ndInactiveLevelEnabled) {
                <div
                  class="col-3 signifyBookmd sliderMinValueNew2">Enable level 2
                  <label [ngClass]="{'disablingInfinteCheck': corridordisbaled, 'infiniteCss': quickConfigvalue===true }"
                    class="enable-feature" aria-hidden="true">
                    <input type="checkbox" [disabled]="corridordisbaled" [checked]="inactiveLevelEnabled"
                      [(ngModel)]="ngModelval['2ndInactiveLevelEnabled']" name="lampDisabled" class="primary-checkbox"
                      [id]="'lampDisabled'" (change)="enableLevel2($event.target.checked)" aria-label="Enable level 2" />
                      <span [id]="'LineSwitch-enableLevel2-checkbox'" class="extra-border-enablefeat"></span>
                    </label>
                  </div>
                }
                @if (column.includes('2ndInactiveDimLevel') && show2ndInactiveDimLevel) {
                  <div id="corridor_ProlongTime_container"
                    class="row slider-container" [ngClass]="{'dtldisbaled': !inactiveLevelEnabled}">
                    <div id="LineSwitch-level2-text" class="col-1 label signifyBookmd text-mindim dim-margin">Level 2</div>
                    @if (!quickConfigvalue) {
                      <span id="LineSwitch-level2-text-min" class="signifyBookmd text-mindim  sliderMinValue col-1"
                      >{{lineswitch2ndInactiveDimLevelMin}}</span>
                    }
                    @if (quickConfigvalue) {
                      <div class="col-2">
                        <div class="row">
                          <div class="col-2"></div>
                          <div class="col-2 minValMargin">
                            <span class=" signifyBookmd minValue"> min {{ lineswitch2ndInactiveDimLevelMin }}</span>
                          </div>
                          <div class="col-2">
                            <span class="signifyBookmd maxValue"> max {{ lineswitch2ndInactiveDimLevelMax }}</span>
                          </div>
                        </div>
                      </div>
                    }
                    @if (!quickConfigvalue) {
                      <div class="col-6 curvePadding sliderCss"
                        [ngClass]="{'disbaleStyle': !inactiveLevelEnabled}">
                        <ngx-slider [options]=lineswitch2ndInactiveDimLevelOption [value]=lineswitch2ndInactiveDimLevelValue
                          (userChangeEnd)="lineswitch2ndInactiveDimLevelChange($event.value)" ngDefaultControl>
                        </ngx-slider>
                      </div>
                    }
                    @if (!quickConfigvalue) {
                      <span id="LineSwitch-level2-text-max" class="signifyBookmd text-mindim  col-1 maxValueCss"
                      >{{lineswitch2ndInactiveDimLevelMax}}</span>
                    }
                    <div class="col-3 d-flex align-items-center">
                      <input type="tel" [value]="lineswitch2ndInactiveDimLevelDisplayValue"
                        (input)="on2ndInactiveDimLevelInput($event.target.value)"
                        (keydown.Tab)="on2ndInactiveDimLevelBlur($event.target.value)" (keydown.enter)="on2ndInactiveDimLevelBlur($event.target.value)"
                        id="lineswitch_2ndInactiveDimLevelValue_txtbox"
                        (keypress)="numberOnly($event)"
                        [ngClass]="{'showingError': inputError['2ndInactiveDimLevel']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
                        class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
                        [disabled]="!inactiveLevelEnabled" />
                        <p class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</p>
                      </div>
                    </div>
                  }
                  @if (column.includes('2ndInactiveLevelDelayTime')&& show2ndInactiveLevelDelayTime) {
                    <div id="corridor_ActivationTime_container"
                      class="row slider-container"
                      [ngClass]="{'dtldisbaled': !inactiveLevelEnabled}">
                      <div id="LineSwitch-delayForLevel2-text" class="col-1 label signifyBookmd text-mindim dim-margin">Delay for level 2</div>
                      @if (!quickConfigvalue) {
                        <span id="LineSwitch-delayForLevel2-text-min" class="signifyBookmd text-mindim  sliderMinValue col-1"
                        >{{lineswitch2ndInactiveLevelDelayTimeMin}}</span>
                      }
                      @if (quickConfigvalue) {
                        <div class="col-2">
                          <div class="row">
                            <div class="col-2"></div>
                            <div class="col-2 minValMargin">
                              <span class=" signifyBookmd minValue"> min {{ lineswitch2ndInactiveLevelDelayTimeMin }}</span>
                            </div>
                            <div class="col-2">
                              <span class="signifyBookmd maxValue"> max {{ lineswitch2ndInactiveLevelDelayTimeMax }}</span>
                            </div>
                          </div>
                        </div>
                      }
                      @if (!quickConfigvalue) {
                        <div class="col-6 curvePadding sliderCss" [ngClass]="{'disbaleStyle': !inactiveLevelEnabled}"
                          >
                          <ngx-slider [options]=lineswitch2ndInactiveLevelDelayTimeOption
                            [value]=lineswitch2ndInactiveLevelDelayTimeValue (mouseup)="sliderEvent(formControl.value)"
                            (userChangeEnd)="lineswitch2ndInactiveLevelDelayTimeChange($event.value)" ngDefaultControl>
                          </ngx-slider>
                        </div>
                      }
                      @if (!quickConfigvalue) {
                        <span id="LineSwitch-delayForLevel2-text-max" class="signifyBookmd text-mindim  col-1 maxValueCss"
                        >{{lineswitch2ndInactiveLevelDelayTimeMax}}</span>
                      }
                      <div class="col-3 d-flex align-items-center">
                        <input type="number" [value]="lineswitch2ndInactiveLevelDelayDisplayValue"
                          (input)="on2ndInactiveLevelDelayTimeInput($event.target.value)"
                          (keydown.Tab)="on2ndInactiveLevelDelayTimeBlur($event.target.value)" (keydown.enter)="on2ndInactiveLevelDelayTimeBlur($event.target.value)"
                          id="lineswitch_2ndInactiveLevelDelayTimeValue_txtbox"
                          (keypress)="numberOnly($event)"
                          [ngClass]="{'showingError': inputError['2ndInactiveLevelDelayTime']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
                          class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
                          [disabled]="!inactiveLevelEnabled" />
                          <p class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">min</p>
                        </div>
                      </div>
                    }
                    <div class="row note-back-new">
                      <span class=" col-8 note-text signifyBookmd note1MarginSpc"><span class="signifyBoldmd">Note 1:</span> On Line
                      Switch Input, High V Level=220-240V and Low V level=
                    Open or 0V</span>
                  </div>
                  <div class="row note-back-new">
                    <span class=" col-11 note-text signifyBookmd"><span class="signifyBoldmd">Note 2:</span> When Line Switch is enabled
                    to override Dynadimmer, the level
                    with the highest percentage is the active(override) level, this could be either High V or Low V level. The level
                  with the lower percentage is ignored by the active Dynadimmer.</span>
                </div>
